import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { animated, config, useTransition } from 'react-spring';
import { RIOJA_RED } from '../colors';
import { Small } from '../Typography';
import { getPx } from '../helpers/common';
import { ExtraSmall as ExtraSmallSpacing } from '../Typography/constants/extra-small.spacing';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../helpers/media-style';

var SPRING_CONFIG = _objectSpread(_objectSpread({}, config.wobbly), {}, {
  clamp: true
});

var StyledWrapper = styled(animated.div)(_templateObject(), function (_ref) {
  var $visible = _ref.$visible;
  return styleForBreakpoints($visible, function ($visible) {
    return "visibility: " + ($visible ? 'visible' : 'hidden') + ";";
  });
}, function (_ref2) {
  var $absolute = _ref2.$absolute;
  return styleForBreakpoints($absolute, function ($absolute) {
    return $absolute ? "\n          position: absolute;\n          left: 0;\n          right: 0;\n          top: 100%;\n        " : '';
  });
}, function (_ref3) {
  var $noPadding = _ref3.$noPadding;
  return styleArrayForBreakpoints([$noPadding, ExtraSmallSpacing], function (_ref4) {
    var $noPadding = _ref4[0],
        $value = _ref4[1];
    return !$noPadding ? "padding-top: " + getPx($value) + ";" : '';
  });
});

var Error = function Error(_ref5) {
  var _ref5$component = _ref5.component,
      Component = _ref5$component === void 0 ? Small : _ref5$component,
      error = _ref5.error,
      _ref5$show = _ref5.show,
      show = _ref5$show === void 0 ? true : _ref5$show,
      _ref5$visible = _ref5.visible,
      visible = _ref5$visible === void 0 ? true : _ref5$visible,
      _ref5$absolute = _ref5.absolute,
      absolute = _ref5$absolute === void 0 ? false : _ref5$absolute,
      _ref5$noPadding = _ref5.noPadding,
      noPadding = _ref5$noPadding === void 0 ? false : _ref5$noPadding,
      props = _objectWithoutPropertiesLoose(_ref5, ["component", "error", "show", "visible", "absolute", "noPadding"]);

  var display = show && error && (typeof error === 'string' || /*#__PURE__*/React.isValidElement(error));
  var transitions = useTransition(display, null, {
    config: SPRING_CONFIG,
    from: {
      opacity: 0,
      transform: 'translate(0, -24px)'
    },
    enter: {
      opacity: 1,
      transform: 'translate(0, 0)'
    },
    leave: {
      opacity: 0
    },
    initial: null,
    immediate: !display
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, transitions.map(function (_ref6) {
    var display = _ref6.item,
        key = _ref6.key,
        transitionStyle = _ref6.props;
    return display && /*#__PURE__*/React.createElement(StyledWrapper, {
      key: key,
      style: transitionStyle,
      $visible: visible,
      $absolute: absolute,
      $noPadding: noPadding
    }, /*#__PURE__*/React.createElement(Component, _extends({
      role: "alert",
      color: RIOJA_RED
    }, props), error));
  }));
};

export default Error;